export default __webpack_public_path__ + "static/media/defendant2-defendant.2a808e16.jpg";